// extracted by mini-css-extract-plugin
var _1 = "ApplicantProfileWidgetStageScreeningStage-moduleApplicantProfileWidgetStageScreeningStage__ZxJ_2";
var _2 = "ApplicantProfileWidgetStageScreeningStage-modulelabel__a0K78";
export { _1 as "ApplicantProfileWidgetStageScreeningStage", _2 as "label" }
